<form #form="ngForm" autocomplete="off">
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <!-- There is an offset of 11 for minLength. There is an issue with ui rich text-->
            <ui-rich-text
                name="description"
                height="500px"
                required
                #description="ngModel"
                [(ngModel)]="jobPosting.description"
                [stripNewlines]="true"
                [displayColorOptions]="true"
                [minlength]="41"
            ></ui-rich-text>
            <mat-error *ngIf="description.invalid">{{
                'applicant-tracker.jobDescriptionError' | appTranslate
            }}</mat-error>
        </mat-form-field>
    </div>
</form>
